import React from "react"
import CurrencyContext from "../../context/CurrencyContext"
import Dropdown from "react-dropdown"

const CurrencyToggle = () => {
  const options = ["INR", "USD", "GBP"]
  return (
    <>
      <CurrencyContext.Consumer>
        {(context) => {
          return (
            <>
              <Dropdown
                options={options}
                onChange={context.chooseMe}
                value={context.defaultValue}
                placeholder="Select an option"
              />
            </>
          )
        }}
      </CurrencyContext.Consumer>
    </>
  )
}

export default CurrencyToggle
